export interface filterEntity {
  id: number
  name: string
}

export interface stringMap {
  title: string
  key: string
}

export enum itemDialogOption {
  SEARCH,
}
